import React from "react";
import { SHELL } from "@/api/connectorPackClient";

export default function AfricaHealthNodeMap({ nodes }) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 16, marginTop: 18 }} data-testid="africa-health-node-map">
      {(nodes || []).map((c) => (
        <div key={c.iso2} style={SHELL.panel}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <h3 style={{ ...SHELL.h2, color: "#c5a059", textTransform: "none", fontSize: 15 }}>{c.country} ({c.iso2})</h3>
            <span style={SHELL.badge(c.live ? "#7AC860" : "#E5A23A")}>{c.status}</span>
          </div>
          <div style={{ ...SHELL.dim, marginTop: 8 }}>Nodes:</div>
          <ul style={{ margin: "4px 0 0 16px", padding: 0, fontSize: 13, color: "#dfe3eb" }}>
            {(c.nodes || []).map((n) => <li key={n}>{n}</li>)}
          </ul>
          <div style={{ ...SHELL.dim, marginTop: 6 }}>Compliance:</div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginTop: 4 }}>
            {(c.compliance_flags || []).map((f) => <span key={f} style={SHELL.badge("#7AC860")}>{f}</span>)}
          </div>
        </div>
      ))}
    </div>
  );
}
